const altTextForHeroImage = "Hero Image"
const connectWithUsText = "Connect with us now!"
const pspSupportSectionListIconUrl =
    "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspsupportsectionlisticon.svg"
export const BUSINESS_PAGE_DATA = {
    widgets: {
        CorporateBusinessPage: {
            analytics: {
                category: "Corporate Wellness",
            },
            mixpanelData: {
                common: {
                    page_name: "corporate_wellness",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Corporate Health & <br/> Wellness",
                subHeader: "For a happy, healthy and productive workforce",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/96968606-ac70-4ba5-8624-907f5982252f.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/409f63c7-4bfa-474e-ba61-4145c7e303fc.svg",
                    alt: altTextForHeroImage,
                },
            },
            supportSection: {
                header: "<span style='color:#FF5443'>Transform your workplace</span> with our wellness offerings",
                listTitle:
                    "<span>Workforce wellness is key to driving productivity, engagement, and retention in any organization. Boost your employees’ morale, reduce absenteeism, and cultivate a culture of well-being with our comprehensive solutions <br/> <br/> Partner with us to meet your organization’s wellness goals.</span>",
                list: [
                    {
                        title: "Compliance & Quality Assurance",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Extensive Network & Reach",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Swift Escalation Resolution",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Customized & Innovative Solutions",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Technology & Product Expertise",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Holistic Insights",
                        image: {
                            url: "https://onemg.gumlet.io/staging/a69b78d5-a9dc-4bb6-80b0-a74b4c3f613d.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/c69799a6-5630-455b-a72a-1fb4fa97fdf2.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "Discover Our <font style='color:#FF5443' >Comprehensive Health Solutions</span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<font style='color:#FF5443'>Build your wellness plan</font> with our modular services",
                bgImage: "https://onemg.gumlet.io/staging/6ff1f9c3-ef73-4108-a5a1-ff6fbe17cd07.svg",
                subText:
                    "We understand the unique health needs of corporate employees, thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                products: [
                    {
                        title: "Annual Health Checkups",
                        description: "Keep your workforce in top shape with regular health assessments",
                        key: "annualHealthCheckups",
                        details: {
                            image: {
                                url: "https://onemg.gumlet.io/staging/53c7612f-fdb0-43a3-9c95-b5841b5a6dfc.svg",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            text: "Our Annual Health Checkup includes an extensive range of tests and screenings, covering both pathology and radiology. We provide customized packages to meet individual health needs, ensuring a thorough examination of your overall well-being.",
                            key: "annualHealthCheckupsPopup",
                            cta: {
                                label: "Know more about Annual Health Checkups",
                            },
                        },
                    },
                    {
                        title: "Cashless Pharmacy",
                        description: "Ensure easy access to medications without the hassle of payments",
                    },
                    {
                        title: "Unlimited E-consultations",
                        description: "Provide round-the-clock access to expert medical advice.",
                    },
                    {
                        title: "Mental Wellness Counseling",
                        description:
                            "Support mental health with personalized one-on-one counseling sessions.",
                    },
                    {
                        title: "Condition Care Management with Second Opinion",
                        description: "Manage chronic conditions with expert guidance and second opinions.",
                    },
                    {
                        title: "Occupational Health Centre Management",
                        description: "Ensure workplace well-being with on-site health services.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/f6f82643-0021-424e-9970-5ac171c2e164.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/1888a61e-0c81-4c80-854d-6333942aa51d.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/563522d0-ba66-416b-a266-82f5dc08683f.svg",
                        alt: "",
                    },
                ],
                showSection: false,
            },

            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                subHeader: connectWithUsText,
                page: "CorporateBusinessPage",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        HospitalServices: {
            analytics: {
                category: "Hospital Services",
            },
            mixpanelData: {
                common: {
                    page_name: "hospital_services",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Hospital Services",
                subHeader:
                    "Your trusted partner for end-to-end pharmacy and supply chain management solutions",
                backgroundImageDweb: {
                    url: " https://onemg.gumlet.io/staging/27fd6ecf-8547-42ad-9240-0ab95f95730c.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: " https://onemg.gumlet.io/staging/27fd6ecf-8547-42ad-9240-0ab95f95730c.svg",
                    alt: altTextForHeroImage,
                },
                cta: {
                    label: "Know more about us",
                    url: "/",
                },
            },
            supportSection: {
                header: "<span><span style='color:#FF5443'>Drive Efficiency</span> and Enhance Your Pharmacy <span style='color:#FF5443'> Operations</span></span>",
                listTitle:
                    "<span>Enhance operational efficiency and revenue growth with our tailored pharmacy management solutions. From cost control to seamless vendor coordination, we ensure your hospital’s pharmacy runs smoothly and efficiently, so you can focus on delivering quality care. <br/> <br/>Partner with us to elevate your hospital’s performance.</span>",
                list: [
                    {
                        title: "Purchase Cost Optimisation ",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Technology-Enabled Operations Management",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Revenue Optimisation",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Pharmacy Leakage Control",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Data-Driven Insights & Analytics",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Comprehensive Vendor & Staff Management",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/ec150621-3ba3-44a3-8bae-cbf087276284.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "4.72/5",
                        description: "NPS",
                    },
                    {
                        title: "350+",
                        description: "OEM Partnerships",
                    },
                    {
                        title: "65+",
                        description: "Hospital Pharmacies ",
                    },
                    {
                        title: "10M+",
                        description: "Patients Served",
                    },
                    {
                        title: "20+",
                        description: "Cities",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span><span style='color:#FF5443'>Revolutionise </span>your <span style='color:#FF5443'>pharmacy operations</span> with our advanced solutions</span>",
                bgImage: "https://onemg.gumlet.io/staging/294a6929-741c-4c3a-81f3-38967f9380f0.svg",
                subText:
                    "Unlock superior financial benefits and operational efficiency with our tailored pharmacy management services, designed to optimise costs, streamline processes, and ensure seamless operations across your hospital.",
                products: [
                    {
                        title: "Cost Efficiency via Purchase Aggregation",
                        description:
                            "Maximise savings through strategic purchase aggregation and bulk buying.",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "Reduced Inventory Holding Costs",
                        description: "Lower storage expenses and optimise your stock management.",
                    },
                    {
                        title: "Minimised Losses from Expiry, Damage & Pilferage",
                        description:
                            "Protect your bottom line by reducing waste and losses with enhanced tracking systems.",
                    },
                    {
                        title: "Streamlined OPD Experience",
                        description:
                            "Cut down waiting times with efficient queue management and home delivery services.",
                    },
                    {
                        title: "Predictive Analytics for Procurement",
                        description:
                            "Prevent stock-outs by anticipating needs through data-driven procurement strategies.",
                    },
                    {
                        title: "Accurate Billing and Reconciliation",
                        description:
                            "Ensure complete billing transparency with 100% reconciliation for seamless financial management.",
                    },
                    {
                        title: "Optimised Stock Management",
                        description:
                            "Maintain a clutter-free and organised inventory with centralised stock control.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: false,
            },
            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                subHeader: connectWithUsText,
                page: "HospitalServicesPage",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        PatientSupportProgram: {
            analytics: {
                category: "Patient Support Program",
            },
            mixpanelData: {
                common: {
                    page_name: "patient_support_program",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Patient Support Programs",
                subHeader: "Empowering patients through holistic care and support",
                backgroundImageDweb: {
                    url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspbackgroundimage.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspbackgroundimage.svg",
                    alt: altTextForHeroImage,
                },
                cta: {
                    label: "Know more about us",
                    url: "/",
                },
            },
            supportSection: {
                header: "<span><span style='color:#FF5443'>Simplify patient care</span> with our tailored support solutions</span>",
                listTitle:
                    "<span>Transforming complex medical journeys with personalised support, authentic medicines, and holistic healthcare solutions to improve health outcomes and quality of life.</br> </br>Collaborate with us to simplify patient outreach through our powerful and trusted distribution network.</span>",
                list: [
                    {
                        title: "Access to genuine specialty medicines",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Affordable healthcare solutions",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Expert guidance & counseling",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Personalised support & holistic care",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Comprehensive authentic resources",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Exceptional patient satisfaction",
                        image: {
                            url: pspSupportSectionListIconUrl,
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                ],
                statsImage: {
                    url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspstats.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "90+",
                        description: "Active Programs",
                    },
                    {
                        title: "3.5M+",
                        description: "Customers Served",
                    },
                    {
                        title: "10+",
                        description: "Therapeutic classes served",
                    },
                    {
                        title: "25+",
                        description: "Audits by Indian & global companies",
                    },
                    {
                        title: "85+",
                        description: "Consistently High NPS",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span><span style='color:#FF5443'>Redefining Patient Journeys</span> with Seamless Support</span>",
                bgImage: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/pspsectionflower.svg",
                subText:
                    "Bridging the gap between affordability, accessibility, and quality care through innovative patient-centric solutions designed specially for complex conditions.",
                products: [
                    {
                        title: "PAN-India Specialty Product Distribution",
                        description:
                            "Comprehensive delivery of cold, cool, and non-cold medicines nationwide.",
                    },
                    {
                        title: "Medicine Authenticity",
                        description: "Ensuring trust with genuine medicines and reliable services.",
                    },
                    {
                        title: "Affordable Treatment Pathways",
                        description:
                            "Empowering patients with flexible financing and cost-effective healthcare solutions.",
                    },
                    {
                        title: "Personalised Holistic Programs",
                        description:
                            "Delivering customised care with counseling, physiotherapy, psychosocial and nutritional education.",
                    },
                    {
                        title: "Streamlined Service Coordination",
                        description:
                            "Simplifying patient experience with single-point-of-contact management.",
                    },
                    {
                        title: "Data-Driven Patient Insights",
                        description:
                            "Enhancing outcomes with analytics-driven care strategies and modular service offerings.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: false,
            },
            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                subHeader: connectWithUsText,
                page: "PatientSupportProgram",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        Insurance: {
            analytics: {
                category: "Insurance",
            },
            mixpanelData: {
                common: {
                    page_name: "insurance",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Healthcare Services for Insurers",
                subHeader:
                    "Your trusted partner in delivering healthcare services for insurers and policyholders.",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/fad885db-34b7-4544-8be3-8bfb22b57670.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/fc176cc1-2204-495a-9875-d425728ba04c.svg",
                    alt: altTextForHeroImage,
                },
                cta: {
                    label: "Know more about us",
                    url: "/",
                },
            },
            supportSection: {
                header: "<span><span style='color:#FF5443'>Streamline Healthcare Services</span> for Insurers and Policyholders</span>",
                listTitle:
                    "<span>Revolutionise your insurance offerings with our extensive healthcare solutions. From pre-policy medicals to cashless services, we ensure efficiency, high-quality care, and an enhanced customer experience for insurers and their clients.</br> </br> Partner with us for end-to-end healthcare services.</span>",
                list: [
                    {
                        title: "Pre-Policy Medical Check-ups (PPMC)",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Annual Health Check-ups (AHCs)",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Medical Examination Reports (MERs)",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Cashless Pharmacy Services",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Cashless Diagnostic Services",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Condition and Care Management",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                    {
                        title: "Value-Added Healthcare Services",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "Delicate lavender flower petal on white.",
                        },
                    },
                ],
                statsImage: {
                    url: "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/insurancestats.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "7",
                        description: "Insurance Partnerships",
                    },
                    {
                        title: "85+",
                        description: "Customer Satisfaction Score",
                    },
                    {
                        title: "154+",
                        description: "Cities Covered",
                    },
                    {
                        title: "200+",
                        description: "Corporate and Insurance Partnerships",
                    },
                    {
                        title: "870",
                        description: "Diagnostic Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span><span style='color:#FF5443'>Enhance Insurance Healthcare</span> with Tailored Solutions</span>",
                bgImage:
                    "https://1mg-gumlet.s3.ap-south-1.amazonaws.com/psp/website/insurancesectionflower.svg",
                subText:
                    "Unlock higher satisfaction and operational efficiency with our advanced healthcare services, offering extensive coverage, high-quality diagnostics, and unparalleled care management.",
                products: [
                    {
                        title: "Comprehensive Diagnostic Services",
                        description:
                            "Multi-format options including at-home, at-centre, hybrid, and camp models.",
                    },
                    {
                        title: "Accredited Labs",
                        description:
                            "NABL and CAP-accredited labs for reliable diagnostics and compliance with top industry standards.",
                    },
                    {
                        title: "Cashless Healthcare Services",
                        description:
                            "Streamlined cashless pharmacy and diagnostic solutions for policyholders.",
                    },
                    {
                        title: "Condition and Care Management",
                        description: "Personalised care programs to enhance customer health outcomes.",
                    },
                    {
                        title: "High-Quality Delivery",
                        description:
                            "Industry-leading NPS and very high SLA compliance for unmatched service excellence.",
                    },
                    {
                        title: "Pan-India Service Capability",
                        description:
                            "Extensive coverage across the country for maximum reach and convenience..",
                    },
                    {
                        title: "Optimised Stock Management",
                        description:
                            "Maintain a clutter-free and organised inventory with centralised stock control.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "air india logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "starbucks logo",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "flower with petals",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "starbucks logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "air india logo",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "flower with petals",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: false,
            },
            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                subHeader: connectWithUsText,
                page: "Insurance",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        HealthPartner: {
            analytics: {
                category: "Strategic Partners",
            },
            mixpanelData: {
                common: {
                    page_name: "strategic_partner",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Your Integrated <br/>Healthcare Partner",
                subHeader: "Empowering health brands to drive meaningful impact through our services",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/72580f19-b9fb-445b-88b8-100147cb01e3.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/897c2ce8-6c4f-4381-b523-588e0da0e6ee.svg",
                    alt: altTextForHeroImage,
                },
            },
            supportSection: {
                header: "<span style='color:#FF5443' >Enhance</span> your healthcare </br> <span style='color:#FF5443'>ecosystem with us</span>",
                listTitle:
                    "<span>We prioritise understanding the specific needs of our health partners, offering customised solutions and competitive pricing to support your customers. Our goal is to empower healthcare businesses and become their preferred fulfilment partner. What sets us apart is our commitment to shared values and aligning with your goals to deliver the best healthcare services within the ecosystem. <br/> <br/> Partner with us to meet your organization’s wellness goals.</span>",
                list: [
                    {
                        title: "Integrated Healthcare system",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Customised Product Integration",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Customer-Centric Approach",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Single Point for Coordination",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Extensive Service Network",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Competitive Pricing",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/e943f834-aa0a-47e6-8919-a45b14e22978.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "<span>Discover Our <span style='color:#FF5443' >Comprehensive Health Solutions</span> </span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span style='color:#FF5443'>Optimise</span> your Healthcare Ecosystem with our<span style='color:#FF5443'> integrated solutions</span>",
                bgImage: "https://onemg.gumlet.io/staging/810f8c74-b343-4d62-b31e-606827607da7.svg",
                subText:
                    " Enhance the user’s healthcare experience by seamlessly integrating our ePharmacy and eDiagnostics product. Models available to integrate:",
                products: [
                    {
                        title: "API Integration",
                        description:
                            "Easily integrate with our fully automated technology suite to offer white-labeled pharmacy and diagnostics services",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "SSO Integration",
                        description:
                            "Deliver a seamless user experience with Single Sign-On, ensuring users stay engaged within their native app",
                    },
                    {
                        title: "Done-in-One Ordering",
                        description:
                            "Streamline the prescription process with a simple upload feature and minimal clicks for quick ordering",
                    },
                    {
                        title: "Customizable Solutions",
                        description:
                            "Tailor our services to meet your specific needs while ensuring a consistent user experience",
                    },
                    {
                        title: "Efficient Order Management",
                        description: "Empower your team to efficiently place and track orders in real-time",
                    },
                    {
                        title: "Transparency & Flexibility",
                        description:
                            "Benefit from clear processes, multiple payment options, priority delivery, and timely order fulfillment",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: true,
            },

            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                page: "HealthPartner",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        HealthAssociates: {
            analytics: {
                category: "Health Associates",
            },
            mixpanelData: {
                common: {
                    page_name: "health_associates",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Health Associate<br/> Program",
                subHeader: "Empowering local entrepreneurs to drive better health outcomes",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/72580f19-b9fb-445b-88b8-100147cb01e3.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/897c2ce8-6c4f-4381-b523-588e0da0e6ee.svg",
                    alt: altTextForHeroImage,
                },
            },
            supportSection: {
                header: "<span>Become a catalyst for <span style='color:#FF5443' >quality healthcare</span></span>",
                listTitle:
                    "<span>Become a vital link in bringing quality healthcare to your community. As a Health Partner, help expand our reach by creating awareness, guiding customers through our offerings, from medicines to health products and diagnostic services.<br/> <br/>Partner with us to play a crucial part in connecting people with our trusted healthcare solutions.</span>",
                list: [
                    {
                        title: "Drive local awareness",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Guide customer decisions",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Facilitate and simplify order placement",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Ensure continued engagement",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Build community trust",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Grow your influence with us",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/91dfefbd-3f75-45d5-8f79-b90f20cd6ff2.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "<span>Discover Our <span style='color:#FF5443' >Comprehensive Health Solutions</span> </span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "Start your <span style='color:#FF5443'>Health Partner </br> Journey </span>with us",
                bgImage: "https://onemg.gumlet.io/staging/810f8c74-b343-4d62-b31e-606827607da7.svg",
                subText:
                    "Partner with Tata 1mg to transform lives in your community while building a successful business for yourself. Join the growing network of health partners who are already making a difference and helping millions stay healthier.",
                products: [
                    {
                        title: "Become an Entrepreneur",
                        description: "Launch your own business with our support",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "Earn on Every Order",
                        description: "Get rewarded for every successful order you deliver",
                    },
                    {
                        title: "Partner with a Leader",
                        description: "Collaborate with India’s top digital healthcare platform",
                    },
                    {
                        title: "Marketing & Tech Support",
                        description: "Access resources to grow your business effectively",
                    },
                    {
                        title: "Training & Insights",
                        description: "Benefit from expert guidance to maximize your success",
                    },
                    {
                        title: "Make an Impact",
                        description: "Help your community access quality and affordable healthcare",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/f6f82643-0021-424e-9970-5ac171c2e164.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/1888a61e-0c81-4c80-854d-6333942aa51d.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/563522d0-ba66-416b-a266-82f5dc08683f.svg",
                        alt: "",
                    },
                ],
                showSection: false,
            },

            form: {
                page: "HealthAssociates",
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                    url: "https://1mg1.viewpage.co/interestform?ignoremxtracking=mxtrue&utm_source=landing_page_promo&utm_medium=web&utm_campaign=adpartners&utm_term=interest_form",
                },
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        AdvertiseWithUs: {
            analytics: {
                category: "Advertise with us",
            },
            mixpanelData: {
                common: {
                    page_name: "advertise_with_us",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Elevate Your Brand’s <br/> Visibility",
                subHeader: "Unlock your brand's potential with our comprehensive marketing solutions",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/72580f19-b9fb-445b-88b8-100147cb01e3.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/897c2ce8-6c4f-4381-b523-588e0da0e6ee.svg",
                    alt: altTextForHeroImage,
                },
                cta: {
                    label: "Know more about us",
                    url: "/",
                },
            },
            supportSection: {
                header: "<span><span style='color:#FF5443'>Amplify</span> Your Brand’s <span style='color:#FF5443'> Impact with Us</span></span>",
                listTitle:
                    "<span>Drive marketing success with our scalable marketing solutions, designed to increase brand visibility, engage customers, and boost sales. Leverage our advanced analytics and customer insights to deliver personalised campaigns that drive measurable results.<br/> <br/> Partner with us to accelerate your business growth.</span>",
                list: [
                    {
                        title: "Data-Driven Campaign Optimization",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Extensive Customer Reach",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Diverse Advertising Channels",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Advanced Analytics & Insights",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Scalable & Flexible Solutions",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Continuous Performance Monitoring",
                        image: {
                            url: "https://onemg.gumlet.io/staging/3eae44ba-d3de-4db3-9629-4e8b5a6beb72.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/279f3d43-7112-43c9-9aa1-da2261056bb8.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "<span>Discover Our <span style='color:#FF5443' >Comprehensive Health Solutions</span> </span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span style='color:#FF5443'>Enhance </span>Your <span style='color:#FF5443'>Brand’s Visibility </span>with Strategic Advertising",
                bgImage: "https://onemg.gumlet.io/staging/810f8c74-b343-4d62-b31e-606827607da7.svg",
                subText:
                    "Our diverse channels and extensive customer reach empower your brand to connect with a highly engaged audience, helping boost your brand’s visibility and drive unparalleled growth.",
                products: [
                    {
                        title: "Trusted Partnership",
                        description: "Work with a trusted industry leader.",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "Targeted Advertising",
                        description: "Reach your audience via tailored strategies",
                    },
                    {
                        title: "Highly Engaged Audience",
                        description: "Connect with a large & active customer base.",
                    },
                    {
                        title: "Multi-Channel Reach",
                        description: "Leverage our extensive range of advertising channels.",
                    },
                    {
                        title: "Customised Solutions",
                        description: "Benefit from personalised strategies  to meet your goals.",
                    },
                    {
                        title: "Content & Insights Driven",
                        description: "Drive impactful campaigns using advanced analytics.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: true,
            },

            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                page: "AdvertiseWithUs",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        AuthorisedDiagnosticCollectionCentre: {
            analytics: {
                category: "Authorised collection centres",
            },
            mixpanelData: {
                common: {
                    page_name: "authorised_collection_store",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Become an Authorised<br/>Diagnostic Collection<br/>Centre Partner",
                subHeader: "Join us to expand & enhance diagnostic service availability",
                backgroundImageDweb: {
                    url: " https://onemg.gumlet.io/staging/27fd6ecf-8547-42ad-9240-0ab95f95730c.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: " https://onemg.gumlet.io/staging/27fd6ecf-8547-42ad-9240-0ab95f95730c.svg",
                    alt: altTextForHeroImage,
                },
                cta: {
                    label: "Know more about us",
                    url: "/",
                },
            },
            supportSection: {
                header: "<span>Partner with Us to<span style='color:#FF5443'> Expand </br> Healthcare Access</span></span>",
                listTitle:
                    "<span>Be a part in revolutionising diagnostic services by becoming a Tata 1mg Labs Authorised Collection Centre Partner. Help extend our reach and make top-quality, accredited healthcare more accessible. Leverage our support and resources to offer accurate, prompt diagnostics in your city. <br/> <br/>Partner with us to make healthcare accessible and affordable in your city.</span>",
                list: [
                    {
                        title: "Provide affordable diagnostics services",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Offer testing services via NABL certified labs",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Provide doctor-curated packages",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Deliver accurate and faster reports",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "3-step lab reports review process",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Opportunity to partner with a trusted brand",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/73dde1d5-f15d-4196-b5a5-e8d3129ab6f9.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "<span>Discover Our <span style='color:#FF5443' >Comprehensive Health Solutions</span> </span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span style='color:#FF5443'>Join us </span>to make a strategic move <span style='color:#FF5443'>towards a healthier business</span>",
                bgImage: "https://onemg.gumlet.io/staging/294a6929-741c-4c3a-81f3-38967f9380f0.svg",
                subText:
                    "As a Tata 1mg Labs Authorised Collection Centre Partner, play a key role in delivering high-quality diagnostics services, while leveraging our robust support and resources. </br></br>Make a significant impact on healthcare accessibility.",
                products: [
                    {
                        title: "Nominal Investment",
                        description: "Begin your journey with a minimal investment of just 3-4 lakhs.",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "360 Degree Support",
                        description: "Receive extensive support from us for smooth operations.",
                    },
                    {
                        title: "Sales Support",
                        description: "Utilise our dedicated sales team to grow your business.",
                    },
                    {
                        title: "National Network",
                        description: "Leverage our extensive pan-India presence for local impact",
                    },
                    {
                        title: "Exclusive Branding",
                        description: "Operate as a distinguished Tata 1mg Collection Centre Partner.",
                    },
                    {
                        title: "Marketing Support",
                        description: "Access our resources to promote the services and attract customers.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/7f0323c0-2798-4de3-b50f-7abdb37e9aee.png",
                        alt: "Air India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/34802cbf-1868-4651-9dd2-7385c175d308.png",
                        alt: "Starbucks",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/029fd791-c0ef-4dc5-aacd-bcba8e3abacf.png",
                        alt: "TCS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/074b7da6-c846-4b05-bba2-0515959c5078.png",
                        alt: "Air India Express",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/07258ed1-6778-40e1-9950-a88c64c04263.png",
                        alt: "Tata Power",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/73981788-697f-4b74-860c-2f6b0b5b7b69.png",
                        alt: "SBI",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/0fa3eb9e-091d-4d00-88b7-c778f2ca0e30.png",
                        alt: "TATA MOTORS",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/ca2db65c-7942-488f-b52b-8f7c2a03c077.png",
                        alt: "IHCL",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/640735f7-a4a4-4579-9b61-eb0c90d21662.png",
                        alt: "Tata Projects",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/224464fb-b803-4c98-a6a3-45c487ec5ade.png",
                        alt: "REA India",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/d2a5d73d-c885-4d82-ad02-cfcb364b0e7f.png",
                        alt: "Tata Aia",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/83075d67-dc94-4c67-915c-e8f477fde81c.png",
                        alt: "Tata Technologies",
                    },
                ],
                showSection: false,
            },

            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                page: "AuthorisedDiagnosticCollectionCentre",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
        Vendors: {
            analytics: {
                category: "Corporate Wellness",
            },
            mixpanelData: {
                common: {
                    page_name: "corporate_wellness",
                    category: "corporate_partnership",
                },
            },
            heroSection: {
                isLeftAligned: true,
                header: "Sell on Tata 1mg",
                subHeader: "Join us to expand your reach and grow your business",
                backgroundImageDweb: {
                    url: "https://onemg.gumlet.io/staging/fad885db-34b7-4544-8be3-8bfb22b57670.svg",
                    alt: altTextForHeroImage,
                },
                backgroundImageMweb: {
                    url: "https://onemg.gumlet.io/staging/fc176cc1-2204-495a-9875-d425728ba04c.svg",
                    alt: altTextForHeroImage,
                },
            },
            supportSection: {
                header: "<span><span style='color:#FF5443'>Drive success</span> by selling<span style='color:#FF5443'> your </br> products</span> on our platform</span>",
                listTitle:
                    "<span>Take your business to the next level by partnering with Tata 1mg, a platform that supports your growth in today's competitive market. Access a vast customer base, enhance your reach, and boost your sales effortlessly.<br/> <br/> Partner with us to unlock limitless opportunities.</span>",
                list: [
                    {
                        title: "Ease of doing business",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Access to a wide customer base",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Streamlined order processing",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Technology-driven operations",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Scalable sales growth",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                    {
                        title: "Transparent end-to-end process",
                        image: {
                            url: "https://onemg.gumlet.io/staging/30e74f07-cde5-410a-82ce-eb6361717389.svg",
                            alt: "logo",
                        },
                    },
                ],
                statsImage: {
                    url: "https://onemg.gumlet.io/staging/15460489-89f0-4efb-876f-3dd5e1fd104b.svg",
                    alt: "Stats Image",
                },
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            solutionSection: {
                header: "<span>Discover Our <span style='color:#FF5443' >Comprehensive Health Solutions</span> </span>",
                solutions: [
                    {
                        title: "Corporate Wellness",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Support your team’s well-being and boost their overall <br /> productivity with our suite of services tailored to meet the <br /> unique needs of your employees.<br /> Our modular offerings include: </span>",

                            textMweb:
                                "<span> Support your team’s well-being and boost their overall productivity with our suite of services tailored to meet the unique needs of your employees. <br /> Our modular offerings include: </span>",

                            list: ["Cashless pharmacy", "Health checkups", "Online doctor consultations"],
                            cta: {
                                label: "Know more about Corporate Solutions",
                            },
                        },
                    },
                    {
                        title: "Health Partners",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span> Join the growing network of health partners and help <br /> millions stay healthier, while building a successful business </span>",
                            textMweb:
                                "<span> Join the growing network of health partners and help millions stay healthier, while building a successful business. </span>",
                            list: [
                                "Become an entrepreneur",
                                "Earn on every order",
                                "Bring quality healthcare to your community",
                            ],
                            cta: {
                                label: "Know more about Health Partners",
                            },
                        },
                    },
                    {
                        title: "Health Associates",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Optimise your healthcare ecosystem with our integrated <br /> solutions across ePharmacy and eDiagnostics.<br/>Our available models include:</span>",
                            textMweb:
                                "<span> Optimise your healthcare ecosystem with our integrated solutions across ePharmacy and eDiagnostics. <br/> Our available models include:</span>",
                            list: ["API Integration", "SSO Integration", "Done-in-One Ordering"],
                            cta: {
                                label: "Know more about Health Associates",
                            },
                        },
                    },
                    {
                        title: "Advertise with us",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Leverage the power of associating with a trusted brand with<br />a wide customer reach and enhance your brand’s visibility.<br/>Advertise with us to get:</span>",
                            textMweb:
                                "<span> Leverage the power of associating with a trusted brand with a wide customer reach and enhance your brand’s visibility <br/> Advertise with us to get:</span>",
                            list: [
                                "Advanced analytics & insights",
                                "Scalable & customised solutions",
                                "Engage with a large & active audience",
                            ],
                            cta: {
                                label: "Know more about Advertising",
                            },
                        },
                    },
                    {
                        title: "Authorised Collection Centres",
                        details: {
                            image: {
                                url: "http://",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            backgroundImage: {
                                url: "",
                                alt: "",
                                width: "",
                                height: "",
                            },
                            textDweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre <br />Partner and deliver high-quality diagnostics services in your <br/>city. Here’s what you gain:</span>",
                            textMweb:
                                "<span>Become a Tata 1mg Labs Authorised Collection Centre Partner and deliver high-quality diagnostics services in your city. Here’s what you gain:</span>",
                            list: [
                                "Start with a nominal investment",
                                "Dedicated sales team focused on growth",
                                "Comprehensive support system",
                            ],
                            cta: {
                                label: "Know more about Authorised Collection Centres",
                            },
                        },
                    },
                ],
            },
            employeeWellBeingSection: {
                header: "Enhancing Employee Well-being",
                subText1:
                    "We understand the unique health needs of corporate employees. thus we offer tailored services designed to promote wellness and support your busy lifestyle. ",
                image: {
                    url: "",
                    alt: "",
                },
                features: [
                    "Annual Health Checkup",
                    "Improve Employee Engagement",
                    "Single point coordination",
                    "Modular and on-demand Plans",
                    "Priority Services",
                    "Health Reports",
                ],
                stats: [
                    {
                        title: "1800+",
                        description: "Cities",
                    },
                    {
                        title: "200+",
                        description: "Corporate Partners",
                    },
                    {
                        title: "1.1M+",
                        description: "Employees Onboarded",
                    },
                    {
                        title: "47M+",
                        description: "Pharmacy Order Delivered",
                    },
                    {
                        title: "30+",
                        description: "Network Partners",
                    },
                ],
            },
            wellnessJourneySection: {
                header: "<span style='color:#FF5443'>Maximize </span>your product's <span style='color:#FF5443'>sales potential</span> with Tata 1mg",
                bgImage: "https://onemg.gumlet.io/staging/14165f6d-b992-4650-a1dd-f914856af9d8.svg",
                subText:
                    "Our comprehensive solutions are designed to ensure your success at every step. Join hands with us to build a world-class healthcare ecosystem for India.",
                products: [
                    {
                        title: "Seamless Operations",
                        description: "Advanced technology to streamline end-to-end processes.",
                        key: "annualHealthCheckups",
                    },
                    {
                        title: "Broad Reach",
                        description: "Connect with over 195 million visitors and boost your sales.",
                    },
                    {
                        title: "Business Growth",
                        description:
                            "Use our platform and marketing tools and services to expand your business.",
                    },
                    {
                        title: "Transparent Costs",
                        description: "No hidden or additional fees from on-boarding to fulfillment.",
                    },
                    {
                        title: "Timely Payments",
                        description: "Receive payments within 7 business days of delivery.",
                    },
                    {
                        title: "Increased Visibility",
                        description:
                            "Avail multiple advertising solutions and customer insights to enhance sales.",
                    },
                ],
            },
            ourJourneySection: {
                header: "Creating <span style='color:#FF5443'>success stories</span> with <span style='color:#FF5443'>our partners</span>",
                subheader: "",
                partners: [
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                    [
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                    ],
                    [
                        {
                            backgroundColor: "rgba(251, 162, 135, 0.15);",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: false,
                        },
                        {
                            backgroundColor: "#E2F1E9",
                            logo: {
                                url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                                alt: "",
                            },
                            highlightText: "Some highlight that we want to show for the success story",
                            cta: {
                                label: "Read more",
                            },
                            absImage: {
                                url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                                alt: "",
                            },
                            active: true,
                        },
                    ],
                ],
                partnersMweb: [
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "#E2F1E9",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                    {
                        backgroundColor: "rgba(251, 162, 135, 0.15);",
                        logo: {
                            url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                            alt: "",
                        },
                        highlightText: "Some highlight that we want to show for the success story",
                        cta: {
                            label: "Read more",
                        },
                        absImage: {
                            url: "https://onemg.gumlet.io/staging/bd4f6a2c-440b-47e8-b4db-8dd62edda1c1.svg",
                            alt: "",
                        },
                    },
                ],

                subText: "Many Other Partners",
                otherPartners: [
                    {
                        url: "https://onemg.gumlet.io/staging/10d350b2-ac28-4164-8658-28a9f51c49c3.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/c6564c17-e1dc-4dca-8696-879d82b98543.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/f6f82643-0021-424e-9970-5ac171c2e164.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/1888a61e-0c81-4c80-854d-6333942aa51d.svg",
                        alt: "",
                    },
                    {
                        url: "https://onemg.gumlet.io/staging/563522d0-ba66-416b-a266-82f5dc08683f.svg",
                        alt: "",
                    },
                ],
                showSection: false,
            },

            form: {
                header: "<span><span style='color:#FF5443'>Let's talk</span> about your business needs</span>",
                page: "Vendors",
                fields: [
                    {
                        type: "text",
                        label: "Name*",
                        name: "name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "email",
                        label: "Work Email ID*",
                        name: "official_email",
                        required: true,
                    },
                    {
                        type: "tel",
                        label: "Contact number*",
                        name: "number",
                        required: true,
                    },
                    {
                        type: "text",
                        label: "Organisation Name*",
                        name: "organization_name",
                        required: true,
                        minLength: 2,
                    },
                    {
                        type: "select",
                        label: "Employee Strength*",
                        name: "employee_strength",
                        required: true,
                        options: [
                            { value: "<500", label: "Less than 500" },
                            { value: "500-2000", label: "500 to 2000" },
                            { value: ">2000", label: "More than 2000" },
                        ],
                    },
                    {
                        type: "select",
                        label: "Services you would like to know about*",
                        name: "required_services",
                        required: true,
                        options: [
                            { value: "Health Checks", label: "Health Checks" },
                            { value: "Medicine Delivery", label: "Medicine Delivery" },
                            { value: "Consultations", label: "Consultations" },
                            { value: "Insurance Products", label: "Insurance Products" },
                            { value: "Medical Rooms", label: "Medical Rooms" },
                            { value: "Other", label: "Other: Please mention in the requirements" },
                        ],
                    },
                    {
                        type: "text",
                        label: "Please mention your requirement",
                        name: "requirement",
                        required: false,
                    },
                ],
                cta: {
                    label: "Get In Touch",
                    type: "primary",
                },
                message: "Your request has been registered! We will get in touch with you shortly.",
            },
            footer: {
                header: "Want to Partner with us?",
            },
        },
    },
}
